import { CheckedAddress } from '@/domain/types/CheckedAddress'

export enum InterestRate {
  Stable = 1,
  Variable = 2,
}

export const NATIVE_ASSET_MOCK_ADDRESS = CheckedAddress('0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE')

export const MAX_INT = BigInt(2 ** 256 - 1)
export const MAX_UINT160 = 2n ** 160n - 1n

export const QUERY_REFETCH_INTERVAL = 2000
export const QUERY_STALE_TIME = 2000

export const ZUSTAND_APP_STORE_LOCAL_STORAGE_KEY = 'zustand-app-store'
export const ZUSTAND_APP_STORE_LOCAL_STORAGE_VERSION = 2

export const apiUrl = process.env.NEXT_PUBLIC_API_URL ?? '/api'
export const blockAnaliticaApiUrl = process.env.NEXT_PUBLIC_BLOCK_ANALITICA_API_URL ?? '/ba-api'
export const infoSkyApiUrl = process.env.NEXT_PUBLIC_INFO_SKY_API_URL ?? '/info-sky-api'
export const faucetUrl = process.env.NEXT_PUBLIC_FAUCET_URL ?? '/claim-with-gas'
export const twitterFollowUrl = process.env.NEXT_PUBLIC_TWITTER_FOLLOW_URL ?? '/verify-follow'

export const HYPURR_UI_REFERRAL_CODE = 0 // 0x0
export const HYPURR_UI_REFERRAL_CODE_BIGINT = BigInt(HYPURR_UI_REFERRAL_CODE)

export const isTestnet = process.env.NEXT_PUBLIC_IS_TESTNET === '1'

export const USDXL_ADDRESS = isTestnet
  ? CheckedAddress('0xfc446B60a054703A9DC096dd397a6e3cdd614275')
  : CheckedAddress('0xca79db4B49f608eF54a5CB813FbEd3a6387bC645')
export const A_USDXL_ADDRESS = isTestnet
  ? CheckedAddress('0xCFBD3c2c0Be381A02fbca18eA8a2231d7C2dE116')
  : CheckedAddress('0x7911c2c9c5f5a6f4Bef58d7dF35903abd3EE9DD6')

// Hide reserves on the UI
export const reserveBlacklist: string[] = []

export const VIEM_TIMEOUT_ON_FORKS = 60_000 // forks tend to be slow. This improves reliability/performance. Default is 10_000

// Swaps
export const GLUEX_EXCHANGE_RATES_URL = 'https://exchange-rates.gluex.xyz'
export const GLUEX_ROUTER_URL = 'https://router.gluex.xyz'
export const GLUEX_ROUTER_ADDRESS = CheckedAddress('0x6Ec7612828B776cC746fe0Ee5381CC93878844f7')
const ROUTER_NAMES: Record<string, string> = {
  [GLUEX_ROUTER_ADDRESS]: 'GlueX',
}
export function getRouterName(address: string): string {
  return ROUTER_NAMES[address] || 'Unknown router'
}

export const PERMIT2_ADDRESS = CheckedAddress('0x000000000022d473030f116ddee9f6b43ac78ba3')

// Isolated pairs
export const USDXL_LHYPE_PAIR_ADDRESS = CheckedAddress('0xAeedD5B6d42e0F077ccF3E7A78ff70b8cB217329')
export const PURR_USDXL_PAIR_ADDRESS = CheckedAddress('0x8001e1e7b05990d22DD8Cdb9737f9fE6589827cE')
export const MHYPE_WHYPE_PAIR_ADDRESS = CheckedAddress('0xE4847Cb23dAd9311b9907497EF8B39d00AC1DE14')
export const HFUN_USDXL_PAIR_ADDRESS = CheckedAddress('0xDC87120DdFC236db5E48e8E0Fee0C4b8c323B64b')
export const CMETH_UETH_PAIR_ADDRESS = CheckedAddress('0x64dF7B4DA81a26A59417857f508B39370138D95e')
export const SUSDE_USDXL_PAIR_ADDRESS = CheckedAddress('0x9136199C9002af633e4d24e4D1c8cCa5192d3dAf')
export const BUDDY_USDXL_PAIR_ADDRESS = CheckedAddress('0x26672D3ef84b53Ddbcd3732e9bc96c3712Ad758d')
export const USOL_USDT0_PAIR_ADDRESS = CheckedAddress('0x34E3d3834B79D77d8558307535Cdf4871B64Bc65')
export const LHYPE_USDT0_PAIR_ADDRESS = CheckedAddress('0x1C5164A764844356d57654ea83f9f1B72Cd10db5')
export const XAUT0_USDT0_PAIR_ADDRESS = CheckedAddress('0x6ecbc0FBE25664C9a1f55aA773f91B77b60E860c')
export const HWHLP_USDT0_PAIR_ADDRESS = CheckedAddress('0x2c910F67DbF81099e6f8e126E7265d7595DC20aD')
export const HWHLP_USDHL_PAIR_ADDRESS = CheckedAddress('0xe8648B00570B5562488d8324c98242EE8FB1A35F')
export const WHLP_USDT0_PAIR_ADDRESS = CheckedAddress('0x6f344dB6b76BE7E110D8AD37d14D5A9F03e2db03')

export const API_INDEXER_URL = process.env.NEXT_PUBLIC_API_INDEXER ?? 'https://indexer.hypurr.fi'

export const DEFAULT_SLIPPAGE = 2e-3
export const APP_DOMAIN = process.env.NEXT_PUBLIC_APP_DOMAIN ?? ''

export const HOST = APP_DOMAIN
  ? APP_DOMAIN.includes('localhost')
    ? `http://${APP_DOMAIN}`
    : `https://${APP_DOMAIN}`
  : 'http://localhost:4000'

export const SWAP_VAULT_CONTRACT = CheckedAddress('0xc4c4D41ba446fbFE44c9b450E7A1aD82312488e0')

export const REFERRAL_REGISTRY_ADDRESS = CheckedAddress('0xd696e6b94ce79fe9aac288c0fc761643219510b6')
export const HYPURR_REFERRAL_KEY = 'hypurrfi-0'
